module.exports = __webpack_public_path__ + "static/media/LK_Information.cd68db2d.svg";